import { ReactElement } from "react";
import { Navigate } from "react-router";
import { accessToken } from "../helpers/sessionKey";

interface IPrivateRoute {
  children: ReactElement;
}

const PrivateRoute = ({ children }: IPrivateRoute) => {
  const token = accessToken();
  if (!token) {
    return <Navigate to="/auth-login" />;
  }
  return children;
};

export default PrivateRoute;
